/*账户相关
i:get || post
h:requestGet ||requestPost
*/
import axios from "../axios";
export default {
  getGetPartTimeInfo: (data) => {
    return axios.get(`/products/part_time/${data.id}/${data.source_type}`);
  },
  // 签署兼职服务协议
  uploadAgreement: (id, data) => {
    return axios.post(`/products/part_time/agreement/${id}`, data);
  },
  // 确认账单
  confirmBill: (id, data) => {
    return axios.post(`/products/part_time/confirm_bill/${id}`, data);
  },
};
